import React, { useEffect, useState, useRef } from 'react';
import styles from "./accordionStyles.module.scss";

const AAccordion = ({
    children,
    onChange = () => { },
    customStyles = {},
    expandIcon = null,
    ...rest
}) => {

    const { expanded } = rest;
    const isControlled = rest.hasOwnProperty('expanded');
    const [summaryComp, ...detailsComp] = React.Children.toArray(children);

    const [localExpanded, setLocalExpanded] = useState(false);
    const detailsCompRef = useRef();

    const isExpanded = isControlled ? expanded : localExpanded;


    const handleExpansionToggle = () => {
        if (isControlled) {
            onChange(!expanded);
            return;
        }

        setLocalExpanded(prev => !prev);
    }

    useEffect(() => {

        if (isExpanded) {
            detailsCompRef.current.style.height = `${detailsCompRef.current.scrollHeight}px`;
        } else {
            detailsCompRef.current.style.height = '0px'
        }

    }, [isExpanded])

    return (
        <div className={styles['accordion']} style={customStyles}>

            <div className={styles["accordion-summary"]} onClick={handleExpansionToggle}>
                {summaryComp}
                <div className={isExpanded ? styles['inverted-icon'] : ''}>{expandIcon}</div>
            </div>



            <div
                ref={detailsCompRef}
                className={styles['accordion-details']}
            >
                {detailsComp}
            </div>


        </div>

    );
}

export default AAccordion;